module.exports = __webpack_public_path__ + "media/kenkeni.76498bd0.wav";